module.exports = {

    props: {
        data: {
            type: Object,
            required: true,
        }
    },

    data() {
        return {
            field_inspection: this.data,

            form: new Form({
                    type: '',
                    trigger: '',
                    employer_id: null,
                    technician_id: '',
                    inspector_id: '',
                    status: null,
                    notified_at: moment().format('Y-MM-DD H:mm:ss'),
                    paid_at: null,
                    review_at: null,
                    scheduled_at: null,
                    project_id: null,
                    inspector_project_id: null,
                    project_number: null,
                    query: '',
                    clearForm: false
                }).dontClear()
        }
    },

    methods: {

        updateProject(project) {
            this.field_inspection['project'] = project;
        },

        fileUploadedEvent() {
            App.bus.$emit('auditable-file-uploaded')
            this.field_inspection.has_files = true;
        },

        fileDeletedEvent(){
            axios.post( `/field-inspections/${this.field_inspection.number}/count-files`).then(response => {
                if (response.data == 0 ) {this.field_inspection.has_files = false}
            });
        }
    },
}
